/* Built In Imports */
import { Field, Form, Formik } from 'formik';
import { useRouter } from 'next/router';
import { createRef, useEffect, useState } from 'react';

/* External Imports */
import { Box, Button, Flex, FormControl, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Radio } from "@chakra-ui/react";
import config from '@config';

/* Internal Imports */

const ProgramCenterPopup = ({ isOpen, onClose, formElement, lang, region }) => {
    const router = useRouter();
    const [err, setErr] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [locationhref, setLocationhref] = useState('');
    const recaptchaRef = createRef(null);

    const [initialValues, setInitialValues] = useState({
        name: '',
        company_name: '',
        email: '',
        whatsapp_number: '',
        interested: ''
    });
    const changeUrl = (e) => {
        let locationhref = '';
        setErr('');
        setSelectedOption(e.target.value);
        if(e.target.value === 'iyc_coimbatore') {
            locationhref = `${config.YOGA_SANDHYA_IYC_LINK}`;
        }
        else {
            locationhref = `${config.YOGA_SANDHYA_SSB_LINK}`;
        }
        setLocationhref(locationhref);
        return;
      };
    const onCloseModal = () => {
        setErr('');
        setSelectedOption('');
        setLocationhref('');
        onClose();
    }

    const handleSubmit = (e, lang, region) => {
        e.preventDefault();
        if (selectedOption != '') {
        setSelectedOption('');
        onClose();
        window.open(`${locationhref}`);
        setLocationhref('');
        } else {
            setErr('Please select location option');
        }
    };
    return (
        <Modal isOpen={isOpen} 
            onClose={
                onClose => {
                onCloseModal();
                }
            }>
            <ModalOverlay />
            <ModalContent maxW={{base:'90%', md:'321px'}} height={'246px'} m="auto" bgColor={'#ffffff'}>
                <ModalCloseButton color={'#000000'} border={'none'}/>
            <ModalBody padding="0px">
                        <Flex
                            flexDirection={"column"}
                            mx={{ base: 'auto' }}
                            alignItems="center"
                            justifyContent="center"
                            backgroundImage={formElement?.bgImage?.desktop}
                            backgroundSize={'cover'}
                            backgroundRepeat={'no-repeat'}
                            padding={{ base: "20px 23px" }}
                            m="0"
                        >
                            <>
                                <Box lineHeight={'40px'} fontFamily="FedraSansStd-book" fontWeight={'400'} color={'#000000'} fontSize={{ base: '16px', md: '16px' }} >
                                    <Box mb="10px" textAlign={'left'} fontFamily="FedraSansStd-book" fontWeight={'bold'} color={'#000000'} fontSize={{ base: '16px', md: '16px' }}>{formElement.title}</Box>
                                    <Formik
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {props => (
                                            <Form onSubmit={props.handleSubmit} className='formAlign'>
                                                <Field name="program">
                                                    {({ field }) => {
                                                        return (
                                                            <FormControl>
                                                                <Box as="label" htmlFor="iyc_coimbatore" display="flex" alignItems="center">
                                                                    <Radio
                                                                        {...field}
                                                                        id="iyc_coimbatore"
                                                                        value="iyc_coimbatore"
                                                                        isChecked={selectedOption === "iyc_coimbatore"}
                                                                        onChange={changeUrl}
                                                                        colorScheme="orange"
                                                                        width={{ base: "26px", md: "40px" }}
                                                                        height={{ base: "26px", md: "40px" }}
                                                                        pl={{base:'0', md:'15px'}}
                                                                        outline="1px solid #D04723"
                                                                        required
                                                                    />
                                                                    <span style={{ marginLeft: "8px" }}>Isha Yoga Center, Coimbatore</span>
                                                                </Box>
                                                            </FormControl>
                                                        );
                                                    }}
                                                </Field>
                                                <Field name="program">
                                                    {({ field }) => {
                                                        return (
                                                            <FormControl>
                                                                <Box as="label" htmlFor="iyc_bangalore" display="flex" alignItems="center">
                                                                    <Radio
                                                                        {...field}
                                                                        id="iyc_bangalore"
                                                                        value="iyc_bangalore"
                                                                        isChecked={selectedOption === "iyc_bangalore"}
                                                                        onChange={changeUrl}
                                                                        colorScheme="orange"
                                                                        width={{ base: "26px", md: "40px" }}
                                                                        height={{ base: "26px", md: "40px" }}
                                                                        pl={{base:'0', md:'15px'}}
                                                                        outline="1px solid #D04723"
                                                                        required
                                                                    />
                                                                    <span style={{ marginLeft: "8px" }}>Sadhguru Sannidhi, Bengaluru</span>
                                                                </Box>
                                                                {err && (
                                                                    <Box
                                                                        justifyContent="center"
                                                                        color="#E73E3E"
                                                                        fontSize="12px"
                                                                        fontFamily="'FedraSansStd-book', sans-serif"
                                                                        marginLeft={"0px"}
                                                                        marginTop={"0px"}
                                                                        height={"27px"}
                                                                        textAlign={"center"}
                                                                    >
                                                                        {err}
                                                                    </Box>
                                                                )}
                                                            </FormControl>
                                                        );
                                                    }}
                                                </Field>
                                                <Box marginTop="0px" width={{ base: '100%' }}>
                                                    <Box as="div" marginTop="20px" textAlign="center">
                                                        <Button
                                                            type="submit"
                                                            display="inline-block"
                                                            mb="0px"
                                                            w={'136px'}
                                                            h={'45px'} onClick={locationhref ? handleSubmit : ''}
                                                            fontFamily="'FedraSansStd-medium', sans-serif"
                                                            borderRadius="8px"
                                                            bgColor={locationhref ? '#FFAE27' : '#FFAE2769'}
                                                            color="#000"
                                                            fontSize="16px"
                                                            padding="10px 35px"
                                                            fontWeight={'normal'}
                                                            // _hover={{
                                                            //     textDecoration: 'none',
                                                            //     bg: !locationhref ? 'rgb(207 69 32 / 41%)' :  '#cf4520',
                                                            //     color: '#fff',
                                                            // }}                                              
                                                            // _focus={{
                                                            //     bg: !locationhref ? 'rgb(207 69 32 / 41%)' : '#cf4520',
                                                            //     border: '1px solid #F5E3B5',
                                                            //     color: '#fff',
                                                            //     }}
                                                            //     _active={{
                                                            //     bg: !locationhref ? 'rgb(207 69 32 / 41%)' : '#cf4520',
                                                            //     border: '1px solid #F5E3B5',
                                                            //     color: '#fff',
                                                            //     }}
                                                            cursor={locationhref ? 'pointer' : 'not-allowed'}
                                                            _hover={{
                                                                bg: locationhref ? '#cf4520' : '',
                                                                color: locationhref ? '#fff' : ''
                                                            }}
                                                            border={"none"}
                                                            isDisabled={locationhref ? false : true}
                                                        // disabled={!props.isValid ? (loading ? true : false) : true}
                                                        >
                                                            {formElement.submitButton}
                                                        </Button>
                                                    </Box>
                                                </Box>
                                            </Form>
                                        )}
                                    </Formik>
                                </Box>
                            </>
                        </Flex>
                        <style jsx global>
                            {`
                            .formAlign{
                                margin-left:-15px;
                            }
                            .bottom-border-fields {
                                border-radius: 5px;
                                padding-left: 30px !important;
                                font-family: "FedraSansStd-book";
                                height: 68px !important;
                                margin-top: 10px;
                                color: #6A6565;
                            }
                            input[type="radio"]:checked, .css-1q5jiny:focus, span.css-1q5jiny[data-focus], span.css-1q5jiny *[data-focus] {
                                background-color: #D04723 !important;
                                border-color: #D04723 !important;
                                outline: 1px solid #D04723 !important;
                            }
                            input[type="radio"] {
                                -webkit-appearance: none;
                                appearance: none;
                                width: 20px;
                                height: 20px;
                                border: 2px solid #D04723;
                                border-radius: 50%;
                                outline: none;
                                cursor: pointer;
                            }
                            input[type="radio"] span {
                                border: none;
                            }
                            input[type="radio"]:checked {
                                background-color: #D04723;
                                border: 2px solid #D04723;
                            }
                            .radio{
                                border:0 !important;
                                background:transparent !important;
                            }
                            .radio:before{
                                background:#CF4520 !important;
                            }
                    `}
                        </style>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ProgramCenterPopup